/* This file is autogenerated, see readme.md for instructions */
import RetentionSvgIcon from '@bloomreach/banana-theme/icons/retention.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RetentionIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RetentionSvgIcon />
    </Icon>
  );
});

RetentionIcon.displayName = 'RetentionIcon';

export default RetentionIcon;
